import React from 'react';
import SlidingSideBar from '../../SlidingSideBar/SlidingSideBar';
import FileExplorer from './FileExplorer';

/** Reusable sidebar around FileExplorer; pass parentFolderName for the group of files to browse. */
const FileExplorerSidebar = ({ show, onHide, parentFolderName, title, zIndex, organized = false, displayName }) => {
  return (
    <SlidingSideBar zIndex={zIndex} visible={show} onClose={onHide} title={title || parentFolderName}>
      {show && <FileExplorer parentFolderName={parentFolderName} organized={organized} displayName={displayName} />}
    </SlidingSideBar>
  );
};

export default FileExplorerSidebar;
